'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    contentEdit: {
      // TODO - fix styles when use in TextField (lineHeight, minHeight, verticalAlign ...)
      width: '100%',
      border: 'none',
      outline: 'none',
      boxSizing: 'border-box',
      overflow: 'auto',
      maxHeight: 108,
      minHeight: 19,
      whiteSpace: 'pre-wrap',
      display: 'inline-block',
      lineHeight: '22px',
      '&:empty:before': {
        content: 'attr(placeholder)',
        display: 'block',
        color: theme.textField.placeholder
      }
    }
  };
};